import { CmsMeta } from './cmsMeta';
import { useConfig } from '../../config';

export const CmsCustomerServiceEmail = () => {
	const { customerServiceEmail } = useConfig();
	return <a href={'mailto:' + customerServiceEmail}>{customerServiceEmail}</a>;
};

export const cmsMeta: CmsMeta = {
	description:
		"The market's customer service email address, resolved at render time. Always use this rather than typing the address.",
	example: ['CmsCustomerServiceEmail', {}],
};
